export function whatsappMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      whatsappId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateWhatsapptId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyWhatsapp(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateWhatsappId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function whatsappMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, whatsappId: json.result.objectId},
  };
}